import Template from './Template'

const Title = [
  "Sweet! You’re on mobile - and you have",
  <img style={{ width: 83, height: 25, marginLeft: 10, marginRight: 10, verticalAlign: "middle" }} src={ require('images/svg/slack-logo-with-name.svg') } />,
  "set up."
]

function launchSlack() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1
  let storeLink
  if (isIOS) {
    storeLink = "https://itunes.apple.com/us/app/slack-team-communication/id618783545"
  } else if (isAndroid) {
    storeLink = "https://play.google.com/store/apps/details?id=com.Slack"
  }
  if (storeLink) {
    setTimeout(function() {
      window.location = storeLink
    }, 25)
  }
  window.location = "slack://"
}

const Button = (
  <button
    className="dsg-LargeButton color-teal"
    onClick={ launchSlack }
  >
    GO TO SLACK
  </button>
)

function makeCopy(channelname) {
  return [
    "Head over to ",
    <span className="dsg-medium-weight">{ channelname }</span>,
    " and start talking to your customers!"
  ]
}

const ConnectedToSlack = ({ channel }) => {
  return (
    <Template
      title={ Title }
      copy={ makeCopy(channel) }
      button={ Button }
    />
  )
}

export default ConnectedToSlack



// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/ConnectedToSlack.js